// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/standard-passenger-weights.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/standard-passenger-weights/standard-passenger-weights.js';

mount([g0]);
